import type { AppConfig } from './types'

declare const __APP_CONFIG__: Record<string, string> | undefined

const raw = typeof __APP_CONFIG__ !== 'undefined' && __APP_CONFIG__ != null ? __APP_CONFIG__ : {}

const Config: AppConfig = {
  API_URL: raw.API_URL ?? '',
  SENTRY_DSN: raw.SENTRY_DSN,
  SENTRY_WEB_DSN: raw.SENTRY_WEB_DSN,
  MAPBOX_ACCESS_TOKEN: raw.MAPBOX_ACCESS_TOKEN ?? '',
  DEMO_MODE: raw.DEMO_MODE,
  APP_VERSION: raw.APP_VERSION,
  FIREBASE_API_KEY: raw.FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: raw.FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: raw.FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: raw.FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: raw.FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: raw.FIREBASE_APP_ID,
  FIREBASE_VAPID_KEY: raw.FIREBASE_VAPID_KEY,
  // iOS/Android wired in Phase 3b; Web Billing key powers Phase 3a (web only).
  REVENUECAT_IOS_KEY: raw.REVENUECAT_IOS_KEY,
  REVENUECAT_ANDROID_KEY: raw.REVENUECAT_ANDROID_KEY,
  REVENUECAT_WEB_KEY: raw.REVENUECAT_WEB_KEY,
}

export default Config
export { Config }
export type { AppConfig } from './types'
